/* eslint-disable */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'redux/reducers';
const initialState = {};

const midleware = [thunk];
export const getStore = () => {
  let newStore = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...midleware)),
  );
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    newStore = createStore(
      rootReducer,
      initialState,
      compose(
        applyMiddleware(...midleware),
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__(),
      ),
    );
  }
  return newStore;
};

export default getStore();
